import type { RouteLocationRaw } from "vue-router";

// Destinations des liens de TileObservationSpecie (composant partagé @carnet/ui).
// Reporte les filtres de l'URL courante vers la page photos (hors filtres propres à la
// liste), en forçant éventuellement le siteId (popup carte, page site).
export function useObservationSpecieLinks(siteId?: MaybeRefOrGetter<number | string | undefined>) {
  const route = useRoute();
  const localePath = useLocalePath();

  const forwardedQuery = computed(() => {
    const { withPhoto: _withPhoto, view: _view, taxons: _taxons, specieFeatures: _specieFeatures, page: _page, ...rest } = route.query;
    const sid = toValue(siteId);
    return sid !== undefined ? { ...rest, siteId: String(sid) } : rest;
  });

  return {
    photosTo: (specie: { id: number }): RouteLocationRaw =>
      localePath({ name: "observations.specie", params: { specieId: specie.id }, query: forwardedQuery.value }),
    detailTo: (specie: { id: number }): RouteLocationRaw => localePath({ name: "species.detail", params: { id: specie.id } }),
  };
}
